// Expire a campaign even when the shopper keeps the page open past its end.
function expireCampaigns() {
  document.querySelectorAll('[data-grit-campaign-end]').forEach((banner) => {
    const end = Number(banner.dataset.gritCampaignEnd);
    if (!Number.isFinite(end) || Date.now() >= end) banner.remove();
  });
}
expireCampaigns();
setInterval(expireCampaigns, 30000);
document.addEventListener('visibilitychange', expireCampaigns);
